import { V2Empty } from '../V2Empty.jsx';
import { useStore } from '../../lib/store.js';

export function V2Pinned({ pinned, threadURN, onScrollTo }) {
  const togglePin = useStore(s => s.togglePin);
  if (!pinned.length) return <V2Empty message="No pinned messages." />;
  return (
    <div className="v2-pinned" data-testid="v2-pinned">
      {pinned.map(msgId => (
        <div key={msgId} className="v2-pinned-row" data-testid="v2-pinned-row">
          <span className="v2-pinned-id mono">{msgId}</span>
          <button
            type="button"
            className="v2-pinned-goto"
            data-testid="v2-pinned-goto"
            onClick={() => onScrollTo?.(msgId)}
          >
            Go to
          </button>
          <button
            type="button"
            className="v2-pinned-unpin"
            data-testid="v2-pinned-unpin"
            onClick={() => togglePin({ threadURN, msgID: msgId })}
          >
            Unpin
          </button>
        </div>
      ))}
    </div>
  );
}
